module.exports = __webpack_public_path__ + "img/google-play-badge.2f151924.png";